import { storageGet, storageRemove, storageSet } from "../../Hook/storage";
/**
 * Recent searches, kept on the device the way the filters are. Queries, not member
 * ids — a recent is "what I typed", so tapping one replays the lookup against
 * whoever answers it today.
 */

const KEY = "s4s-recent-searches";
const MAX = 8;

export function getRecents(): string[] {
  try {
    const raw = storageGet(KEY);
    const list = raw ? JSON.parse(raw) : [];
    return Array.isArray(list) ? list.filter((entry) => typeof entry === "string") : [];
  } catch {
    return [];
  }
}

/** Recorded when a search concludes — a profile opened, or the query handed to the feed. */
export function addRecent(query: string): string[] {
  const q = query.trim();
  if (!q) return getRecents();
  const list = [
    q,
    ...getRecents().filter((entry) => entry.toLowerCase() !== q.toLowerCase()),
  ].slice(0, MAX);
  storageSet(KEY, JSON.stringify(list));
  return list;
}

export function removeRecent(query: string): string[] {
  const list = getRecents().filter((entry) => entry !== query);
  storageSet(KEY, JSON.stringify(list));
  return list;
}

export function clearRecents(): string[] {
  storageRemove(KEY);
  return [];
}
